import dayjs from 'dayjs';
import { Box, Typography } from '@mui/material';

const copyrightDate = dayjs(Date.now()).get('year');

const getContainerStyles = ({ breakpoints }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignSelf: 'center',

  [breakpoints.up('md')]: {
    justifyContent: 'flex-start',
    alignSelf: 'flex-start',
  },
});

const Footer = () => (
  <Box sx={getContainerStyles}>
    <Typography variant="body1">{`© ${copyrightDate} Cultural Calculator`}</Typography>
  </Box>
);

export default Footer;
